export const APP_ROUTES = {
  root: '/',
  noAccess: '/noAccess',
  reports: '/reports',
  oauthCallback: '/oauth2/idpresponse',
  exceptions: '/exceptions',
  exclusions: '/exclusions',
  internalReview: '/internalReview',
  falseNegatives: '/falseNegatives',
  fleet: {
    root: '/fleet',
    health: '/fleet/health',
    map: '/fleet/map',
    table: '/fleet/table',
  },
  matchesReviewGrid: '/matchesReviewGrid',
  groupsReview: '/groupsReview',
  portalList: '/portalList',
  default: '/portalList',
  portalMap: '/portalMap',
  reviewGrid: '/reviewGrid',
  reviewQueue: '/reviewQueue',
  routeEditor: '/routeViewer',
  routeSelector: '/routeSelector',
  settings: '/settings',
  setupMFA: '/setupMFA',
  setupMFASMS: '/setupMFASMS',
  spotlight: '/spotlight',
  insights: '/insights',
  forgotPassword: '/forgotPassword',
  setupNewPassword: '/setupNewPassword',
  changePassword: '/changePassword',
  fleetWizard: {
    root: '/fleetWizard',
    setupFleet: '/fleetWizard/setupFleet',
    fleetAuthorities: '/fleetWizard/fleetAuthorities',
    fleetRejectionReason: '/fleetWizard/fleetRejectionReason',
    fleetEventTypes: '/fleetWizard/fleetEventTypes',
    fleetMatchDetectorConfig: '/fleetWizard/fleetMatchDetectorConfig',
    fleetEventsBusinessRules: '/fleetWizard/fleetEventsBusinessRules',
    fleetHealthSettings: '/fleetWizard/fleetHealthSettings',
    fleetSummary: '/fleetWizard/fleetSummary',
  },
  authorityWizard: {
    root: '/authorityWizard',
    setupAuthority: '/authorityWizard/setupAuthority',
    evidenceSchedulerConfig: '/authorityWizard/evidenceSchedulerConfig',
    volationProcessor: '/authorityWizard/violationProcessor',
    authoritySummary: '/authorityWizard/authoritySummary',
  },
} as const;

export const APP_TITLES: Record<keyof typeof APP_ROUTES, string> = {
  root: 'Login',
  reports: 'Reports',
  oauthCallback: '',
  exceptions: 'Enforcement exceptions',
  exclusions: 'Licence plate exclusions',
  internalReview: 'Internal review queue',
  falseNegatives: 'False negative tool',
  fleet: 'Fleet health',
  matchesReviewGrid: 'Matches review grid',
  groupsReview: 'Groups review',
  portalList: 'Events list',
  default: 'Login',
  portalMap: 'Events map',
  reviewGrid: 'Review grid',
  reviewQueue: 'Review queue',
  routeEditor: 'Route editor',
  routeSelector: 'Route selector',
  settings: 'Settings',
  setupMFA: 'Setup MFA',
  setupMFASMS: 'Setup SMS MFA',
  spotlight: 'Spotlight',
  insights: 'Insights',
  forgotPassword: 'Forgot Password',
  setupNewPassword: 'Setup New Password',
  changePassword: 'Change Password',
  fleetWizard: 'Fleet Wizard',
  authorityWizard: 'Authority Wizard',
  noAccess: 'No access',
};
